
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 8,
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrow-down_a6bf99b92e111f53__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.456 1.26a.874.874 0 0 1 1.304.067c.316.378.317.945.019 1.323l-.081.09-5.077 5a.87.87 0 0 1-1.15.08l-.092-.08-5.077-5A1.06 1.06 0 0 1 .24 1.327a.873.873 0 0 1 1.214-.146l.09.08 4.455 4.388 4.457-4.389Z",
  fill: "var(--theme-primary, #810ea9)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow-down_a6bf99b92e111f53__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-light, #f9f3fb)",
  transform: "rotate(-90 4 4)",
  d: "M0 0h8v12H0z"
})))));

      const __svgRaw = "<svg width=\"12\" height=\"8\" viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g clip-path=\"url(#clip0_5118_7454)\">\r\n<path d=\"M10.456 1.26007C10.8332 0.888561 11.417 0.918677 11.7599 1.32733C12.0765 1.70456 12.0772 2.27246 11.7787 2.6498L11.6978 2.73995L6.62093 7.73994C6.29819 8.05779 5.81948 8.08428 5.47074 7.8194L5.37907 7.73994L0.302154 2.73995C-0.0750677 2.36844 -0.102868 1.73599 0.240062 1.32733C0.556611 0.950112 1.0784 0.895433 1.4535 1.18145L1.54401 1.26007L5.99908 5.649L10.456 1.26007Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</g>\r\n<defs>\r\n<clipPath id=\"clip0_5118_7454\">\r\n<rect width=\"8\" height=\"12\" fill=\"var(--theme-light, #f9f3fb)\" transform=\"translate(0 8) rotate(-90)\"/>\r\n</clipPath>\r\n</defs>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/arrow-down.a6bf99b92e111f5307977aadbbee164a.svg"),
        {
          React: SvgArrowDown,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      